<div class="gantt-page-container" [class.p-3]="!embedded" [class.embedded]="embedded">
	<mat-card [class.p-4]="!embedded" class="h-100">
		@if (!embedded) {
		<mat-card-header>
			<mat-card-title class="d-flex justify-content-between align-items-center w-100">
				<app-nav-map></app-nav-map>
				@if (loading) {
				<mat-spinner diameter="16" class="mt-2 ms-2"></mat-spinner>
				}
			</mat-card-title>
		</mat-card-header>

		<mat-divider class="w-75 mb-3"></mat-divider>
		}

		<div class="d-flex flex-wrap align-items-center justify-content-between pb-3">
			<mat-button-toggle-group [(ngModel)]="selectedDay" (change)="onDayChange()">
				@for (day of daysOfWeek; track day) {
				<mat-button-toggle [value]="day">{{ 'MEDIUM.DAYS.' + day | translate }}</mat-button-toggle>
				}
			</mat-button-toggle-group>

			<div class="d-flex align-items-center zoom-control">
				<span class="zoom-label">{{ 'RECORDING_SCHEDULE_GANTT.ZOOM' | translate }}:</span>
				<mat-button-toggle-group [(ngModel)]="zoom" (change)="onZoomChange()">
					@for (level of zoomLevels; track level) {
					<mat-button-toggle [value]="level">{{ level === 1 ? ('RECORDING_SCHEDULE_GANTT.ZOOM_FULL_DAY' | translate) : level + '×' }}</mat-button-toggle>
					}
				</mat-button-toggle-group>
			</div>

			<div class="d-flex align-items-center recording-switch">
				<mat-slide-toggle [checked]="recordingEnabled" [disabled]="loading || savingSwitch" (change)="onRecordingToggle($event)">
					<span [class.switch-on]="recordingEnabled">{{ (recordingEnabled ? 'RECORDING_SCHEDULE_GANTT.RECORDING_ON' : 'RECORDING_SCHEDULE_GANTT.RECORDING_OFF') | translate }}</span>
				</mat-slide-toggle>
				<mat-slide-toggle class="ms-3" [checked]="segmentationEnabled" [disabled]="loading || savingSwitch" (change)="onSegmentationToggle($event)">
					{{ 'RECORDING_SCHEDULE_GANTT.SEGMENTATION' | translate }}
				</mat-slide-toggle>
				<mat-slide-toggle class="ms-3" [checked]="transcriptionEnabled" [disabled]="loading || savingSwitch" (change)="onTranscriptionToggle($event)">
					{{ 'RECORDING_SCHEDULE_GANTT.TRANSCRIPTION' | translate }}
				</mat-slide-toggle>
				<mat-slide-toggle class="ms-3" [checked]="autoCreateClipsEnabled" [disabled]="loading || savingSwitch" (change)="onAutoCreateClipsToggle($event)">
					{{ 'RECORDING_SCHEDULE_GANTT.AUTO_CREATE_CLIPS' | translate }}
				</mat-slide-toggle>
			</div>

			<div class="d-flex flex-wrap legend">
				@for (entry of usernameLegend; track entry.username) {
				<span class="legend-item"><span class="legend-swatch" [style.background]="entry.color"></span>{{ entry.username }}</span>
				}
				<span class="legend-item"><span class="legend-swatch" [style.background]="usernameColor(null)"></span>{{ 'RECORDING_SCHEDULE_GANTT.NO_SUBSCRIPTION' | translate }}</span>
				<span class="legend-item"><span class="legend-swatch disabled"></span>{{ 'RECORDING_SCHEDULE_GANTT.DISABLED' | translate }}</span>
				<span class="legend-item"><span class="legend-swatch conflict"></span>{{ 'RECORDING_SCHEDULE_GANTT.CONFLICT' | translate }}</span>
			</div>
		</div>

		@if (!loading && mediumRows.length === 0) {
		<p class="text-center py-4">{{ 'RECORDING_SCHEDULE_GANTT.EMPTY' | translate }}</p>
		}

		@if (mediumRows.length > 0) {
		<div class="gantt" #ganttScroll>
			<div class="gantt-header" [style.min-width.px]="timelineMinWidthPx">
				<div class="gantt-row-label"></div>
				<div class="gantt-timeline">
					@for (hour of hours; track hour) {
					<span class="gantt-hour-label" [style.left]="(hour / 24) * 100 + '%'">{{ hour.toString().padStart(2, '0') }}</span>
					}
				</div>
			</div>

			@for (row of mediumRows; track row.mediumId) {
			<div class="gantt-row" [style.min-width.px]="timelineMinWidthPx">
				<div class="gantt-row-label">
					<span class="medium-name">{{ row.name }}</span>
					<span class="medium-type">{{ 'MEDIUM.TYPES.' + row.type | translate }}</span>
					<button
						mat-icon-button
						class="add-schedule-btn"
						type="button"
						(click)="addScheduleForMedium(row)"
						matTooltip="{{ 'RECORDING_SCHEDULE_GANTT.ADD_SCHEDULE_FOR_MEDIUM' | translate }}">
						<mat-icon>add</mat-icon>
					</button>
				</div>
				<div class="gantt-timeline">
					@for (hour of hours; track hour) {
					<span class="gantt-gridline" [style.left]="(hour / 24) * 100 + '%'"></span>
					}
					@if (zoom > 1) {
					@for (minute of quarterMinutes; track minute) {
					<span class="gantt-gridline quarter" [ngStyle]="quarterStyle(minute)"></span>
					}
					}
					@for (range of conflictBands; track $index) {
					<span class="gantt-conflict-band" [ngStyle]="conflictBandStyle(range)"></span>
					}
					@for (block of schedulesForMedium(row.mediumId); track block.id) {
					<span
						class="gantt-block"
						[class.disabled]="!block.enabled"
						[class.conflict]="isInConflict(block.id)"
						[ngStyle]="blockStyle(block)"
						matTooltip="{{ formatTimeRange(block) }} · {{ block.iptvUsername || ('RECORDING_SCHEDULE_GANTT.NO_SUBSCRIPTION' | translate) }}"
						matTooltipPosition="above">
						{{ blockLabel(block) }}
					</span>
					}
				</div>
			</div>
			}
		</div>
		}
	</mat-card>
</div>
